export const STO_PICK_ROUTE_ROOT = '/sto-pick';

export const STO_PICK_ROUTES = {
  STO_PICK: STO_PICK_ROUTE_ROOT,
  ASSIGN: `${STO_PICK_ROUTE_ROOT}/assign`,
  LIST: `${STO_PICK_ROUTE_ROOT}/list`,
  ITEM: `${STO_PICK_ROUTE_ROOT}/item`,
  SUMMARY: `${STO_PICK_ROUTE_ROOT}/summary`,
} as const;
